import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import 'rxjs/add/operator/map';
import { GlobalsService } from "../../shared/shared";

@Component({
    selector: 'impressum',
    templateUrl: 'impressum.component.html',
    styleUrls: ['impressum.component.css']

})
export class ImpressumComponent implements OnInit {

    constructor(private router: Router, private globalSrv: GlobalsService) {
    }

    ngOnInit() {
    }
}


// WEBPACK FOOTER //
// ./src/app/_vertrag/impressum/impressum.component.ts